import React from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../../assets/images/icons/mercury-pc.png';

const MessengerNoAccount = () => {
    const navigate = useNavigate();

    const onClickBack = () => {
        navigate('/login', { replace: true });
    };

    return (
        <div className="mlp-root">
            <div className="mlp-card">

                {/* Logo */}
                <div className="mlp-logo">
                    <img src={Logo} alt="Mercury" />
                </div>

                {/* Icon + Message */}
                <div className="mlp-noaccount">
                    <div className="mlp-noaccount-icon">
                        <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                            <circle cx="12" cy="12" r="12" fill="#FEF9C3" />
                            <path
                                d="M12 5a7 7 0 100 14A7 7 0 0012 5zm0 0v0zm0 4v4m0 3h.01"
                                stroke="#CA8A04"
                                strokeWidth="1.8"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <line x1="6" y1="6" x2="18" y2="18" stroke="#CA8A04" strokeWidth="1.8" strokeLinecap="round" />
                        </svg>
                    </div>
                    <p className="mlp-noaccount-title">ไม่พบบัญชีเข้าใช้งาน</p>
                    <p className="mlp-noaccount-sub">กรุณาติดต่อแอดมิน</p>
                </div>

                {/* Back Button */}
                <button
                    className="mlp-btn mlp-btn--primary"
                    onClick={onClickBack}
                >
                    รับทราบ
                </button>

            </div>
        </div>
    );
};

export default MessengerNoAccount;